import defaultAttributes from '../defaultAttributes';

const Circle = [
  'svg',
  defaultAttributes,
  [['circle', { cx: '12', cy: '12', r: '10' }]],
];

export default Circle;
